"use client";

import { useQuery, useQueryClient } from "@tanstack/react-query";

import { useNavigationApi } from "../hooks";

export const USER_NAMESPACES_QUERY_KEY = "organization/account/namespace";

export const useQueryUserNamespaces = (enabled?: boolean) => {
  const { api } = useNavigationApi();

  return useQuery({
    queryKey: [USER_NAMESPACES_QUERY_KEY],
    queryFn: () => api.navigation.listUserNamespaces(),
    enabled,
  });
};

export const useInvalidateUserNamespaces = () => {
  const queryClient = useQueryClient();

  return () =>
    queryClient.invalidateQueries({
      queryKey: [USER_NAMESPACES_QUERY_KEY],
    });
};
